import { validator } from './validator.js';
export const required = validator((_) => _ !== null && _ !== undefined && _ !== '');
//# sourceMappingURL=required.js.map